import { render, staticRenderFns } from "./ArticleManager.vue?vue&type=template&id=527df3d4&scoped=true&"
import script from "./ArticleManager.vue?vue&type=script&lang=js&"
export * from "./ArticleManager.vue?vue&type=script&lang=js&"
import style0 from "./ArticleManager.vue?vue&type=style&index=0&id=527df3d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527df3d4",
  null
  
)

export default component.exports